import React, { useEffect } from 'react';
import moment from 'moment';
import { withRouter } from 'react-router-dom';

import useGlobal from '../../../store';
import Table from '../../../facturotopia/table/Table';
import RetencionListItemStatus from './components/RetencionListItemStatus';

const mapState = (store) => {
  return store.app.retenciones.list;
};

const mapActions = (actions) => {
  return actions.app.retenciones.list;
};

const RetencionList = (props) => {

  const [state, actions] = useGlobal(mapState, mapActions);

  const { busy, data } = state;

  useEffect(() => {
    if (data.length === 0) {
      const from = moment().subtract(7, 'days').format('YYYY-MM-DD');
      const to = moment().format('YYYY-MM-DD');

      actions.paginate({
        page: 1,
        from,
        to
      })
    }
  }, []); // eslint-disable-line

  const paginate = (meta) => {
    const { from = '', to = '' } = state.filters;

    const newMeta = {
      ...meta,
      from,
      to
    }

    actions.paginate(newMeta);
  }

  const handleOnPageChange = (page) => {
    paginate({ page });
  }

  const handleOnPageLimitChange = (limit) => {
    paginate({ limit, page: 1 });
  }

  const getPaginationConfig = () => {
    const { pagination } = state;

    return {
      metadata: pagination,
      onPageChange: handleOnPageChange,
      onPageLimitChange: handleOnPageLimitChange
    }
  }

  const getRowSelectionConfig = () => {
    const { selectable, selectedRowKeys } = state;

    if (!selectable) {
      return null;
    }

    return {
      type: 'checkbox',
      selectedRowKeys,
      onChange: handleRowSelectionChange,
      getCheckboxProps: record => ({
        name: record.name,
      }),
    }
  }

  const handleRowSelectionChange = ({selectedRowKeys, selectedRows}) => {
    const { onRowSelectionChange } = props;

    onRowSelectionChange && onRowSelectionChange({selectedRowKeys, selectedRows});
  }

  const { onRowClick } = props;

  return (
    <Table
      loading={ busy }
      columns={ columns }
      rowKey={ 'id' }
      pagination={ getPaginationConfig() }
      data={ data }
      rowSelection={ getRowSelectionConfig() }
      onRowClick={ onRowClick }
      onRow={ (item) => {
        return {
          className: item.highlight ? 'row-highlighted' : ''
        }
      }
    }
    >
    </Table>
  );
}

const columns = [
  {
    align: 'center',
    key: 'status',
    title: 'Status',
    dataIndex: 'status',
    render: (item) => <RetencionListItemStatus status={ item.status } />
  },
  {
    key: 'timbrado_at',
    title: 'Fecha',
    dataIndex: 'timbrado_at',
  },
  {
    key: 'emisor_rfc',
    title: 'Emisor',
    dataIndex: 'emisor_rfc',
  },
  {
    key: 'receptor_rfc',
    title: 'Receptor',
    dataIndex: 'receptor_rfc',
  },
  {
    key: 'monto_operacion',
    title: 'Monto',
    dataIndex: 'monto_operacion',
  },
  {
    key: 'monto_retenido',
    title: 'Retenido',
    dataIndex: 'monto_retenido',
  },
  {
    key: 'folio',
    title: 'Folio Int.',
    dataIndex: 'folio',
  },
  {
    key: 'uuid',
    title: 'Folio Fiscal',
    dataIndex: 'uuid',
  },
];

export default withRouter(RetencionList);
